// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a7a75f66","453":"810cbe4e","455":"f0834049","977":"1db86666"}[chunkId] + ".chunk.js";
};